import { Sparkles } from "lucide-react";
import { useState } from "react";
import { useLocation } from "react-router";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth";
import { ASSISTANT_MODULE } from "@/features/assistant/constants";
import { useClientModules } from "@/hooks/useClientModules";

import { AssistantPanel } from "./AssistantPanel";

export function AssistantLauncher() {
  const { isAuthenticated } = useAuth();
  const { data: modules } = useClientModules();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const enabled =
    isAuthenticated &&
    (modules ?? []).some((m) => m.module === ASSISTANT_MODULE);
  // Na página do assistente o chat já está na tela.
  if (!enabled || pathname.startsWith("/assistente")) return null;

  return (
    <>
      <Button
        // No desktop a sidebar (fixed, z-50) ocupa até 17rem à esquerda: o botão fica à direita dela.
        className="fixed bottom-4 left-4 z-40 h-12 w-12 rounded-full shadow-lg lg:left-[18rem]"
        size="icon"
        aria-label="Abrir assistente"
        onClick={() => setOpen(true)}
        data-testid="assistant-launcher"
      >
        <Sparkles className="h-5 w-5" />
      </Button>
      <AssistantPanel open={open} onOpenChange={setOpen} />
    </>
  );
}
